import {
  name as elearning,
  reducer as elearningsReducer,
} from '@/modules/reducers/elearning';

import {
  name as myElearning,
  reducer as myElearningsReducer,
} from '@/modules/reducers/myElearning';

import {
  name as courseLibrary,
  reducer as courseLibraryReducer,
} from '@/modules/reducers/courseLibrary';

import { name as quiz, reducer as quizReducer } from '@/modules/reducers/quiz';
import {
  name as flashMessage,
  reducer as flashMessageReducer,
} from '@/modules/reducers/flashMessage';

import {
  name as theme,
  reducer as themeReducer,
} from '@/modules/reducers/theme';

import {
  name as audioPlayer,
  reducer as audioPlayerReducer,
} from '@/modules/reducers/audioPlayer';

import {
  name as videoPlayer,
  reducer as videoPlayerReducer,
} from '@/modules/reducers/videoPlayer';

import {
  name as template,
  reducer as templateReducer,
} from '@/modules/reducers/template';

import {
  name as elearningPlayer,
  reducer as elearningPlayerReducer,
} from '@/modules/reducers/elearningPlayer';

import {
  name as elearningReviewers,
  reducer as elearningReviewersReducer,
} from '@/modules/reducers/elearningReviewers';

import {
  name as elearningComments,
  reducer as elearningCommentsReducer,
} from '@/modules/reducers/comments';

import rootServices from '@/modules/services';

export default {
  [rootServices.reducerPath]: rootServices.reducer,
  [myElearning]: myElearningsReducer,
  [courseLibrary]: courseLibraryReducer,
  [elearning]: elearningsReducer,
  [flashMessage]: flashMessageReducer,
  [theme]: themeReducer,
  [quiz]: quizReducer,
  [audioPlayer]: audioPlayerReducer,
  [elearningPlayer]: elearningPlayerReducer,
  [elearningReviewers]: elearningReviewersReducer,
  [videoPlayer]: videoPlayerReducer,
  [template]: templateReducer,
  [elearningComments]: elearningCommentsReducer,
};
